<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <div class="dispatch-table">
          <b-card header>
            <div slot="header">
              <span>CheckList</span>
              <a
                href="#"
                class="btn btn-sm btn-info float-right ml-1"
                id="printpagebutton"
                @click="onPrint"
              >
                <i class="fa fa-print"></i> Print
              </a>
              <button
                id="printexport"
                class="btn btn-sm btn-info float-right"
                @click="onexport"
              >Export</button>
            </div>
            <div class="newButton">
              <b-button
                variant="primary"
                class="btnsm"
                @click="OnClinkNEwChecklist()"
              >
                <i class="fa fa-plus-circle"></i>&nbsp;New Checklist
              </b-button>
            </div>
            <b-row>
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="1" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search" />
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>&nbsp;
            <b-table
              show-empty
              stacked="md"
              responsive="sm"
              hover
              small
              striped
              fixed
              head-variant="light"
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :filter="filter"
            >
              <template v-slot:cell(action_button)="data">
                    <b-button
                    variant="primary"
                    class="btn btn-primary btn-sm btn-square"
                    @click="OnClinkUpdateChecklist(data.item.checklistId)"
                  >
                   <i class="fa fa-pencil-square-o"></i>
                  </b-button>&nbsp;
                <!-- <router-link
                  tag="button"
                  :to="'/Maintenance/2017042410233814/modify/check/' + data.item.checklistId"
                  class="btn btn-primary btn-sm btn-square"
                >
                  <i class="fa fa-pencil-square-o"></i>
                </router-link> -->
                <b-button
                  size="sm"
                  variant="danger"
                  class="btn btn-danger btn-sm btn-square"
                  @click="onSelecteItemToDelete(data.item)"
                >
                  <i class="fa fa-trash-o"></i>
                </b-button>
              </template>
              <template v-slot:cell(status)="data">
                <i
                  :class="data.item.status == 'A' ?  'activeStatus icon-check active_icon' : 'inactiveStatus icon-close inactive_icon'"
                ></i>
              </template>
            </b-table>
          </b-card>
          <div style="margin-top:5px;">
            <b-pagination
              size="sm"
              :total-rows="totalItem"
              v-model="currentPage"
              :per-page="perPage"
              @input="onPageSelect"
            ></b-pagination>
          </div>
        </div>
        <div class="dispatch-list">
          <div>
            <p>Checklist</p>
          </div>
          <div class="newButton">
            <b-button
              variant="primary"
              class="btnsm"
               @click="OnClinkNEwChecklist()"
            >
              <i class="fa fa-plus-circle"></i>&nbsp;New Checklist
            </b-button>
          </div>
          <b-list-group v-for="(item,index) in items" :key="`dynlist-${index}`" class="shadow">
            <b-list-group-item class="flex-column align-items-start">
              <div class="list-field">
                <span class="mb-1 dis">Groupcode:</span>
                <span>{{item.groupcode}}</span>
              </div>
              <div class="list-field">
                <span class="mb-1 dis">Description:</span>
                <span>{{item.checklistdescription}}</span>
              </div>
              <div class="list-field">
                <span class="mb-1 dis">Status:</span>
                <span>
                  <i
                    :class="item.status == 'A' ?  'activeStatus icon-check active_icon' : 'inactiveStatus icon-close inactive_icon'"
                  ></i>
                </span>
              </div>
              <hr />
              <div class="row">
                <div class="col">

                <b-button
                    variant="primary"
                     class="btn btnsm btn-primary btn-block"
                    @click="OnClinkUpdateChecklist(item.checklistId)"
                  >
                    <i class="fa fa-pencil-square-o"></i>
                      Edit
                  </b-button>
                  <b-button
                    class="btn btnsm btn-danger btn-block"
                    @click="onSelecteItemToDelete(item)"
                  >
                    <span class="text-light">
                      <i class="fa fa-trash-o"></i>
                      Remove
                    </span>
                  </b-button>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
        <b-modal title="System Message" v-model="deleteModal" @ok="onDeleteItem">
          Are you sure you want to remove
          <strong>{{selectedItemLabel}} ?</strong>
        </b-modal>
      </b-col>

    </b-row>
  </div>
</template>

<script>
import JSONToCSVConvertor from "../../../src/services/JSONToCSVConvertor.js";
import miniToastr from "mini-toastr";
import api from "../../services/api";
export default {
  data: function() {
    return {
      deleteModal: false,
      selectedItem: {},
      selectedItemLabel: "",
      groupId: this.$route.params.id,
      perPage: this.$store.getters.perPage,
      totalItem: 0,
      currentPage: 1,
      isBusy: false,
      sortOptions: [],
      filter: null,
      fields: [
        {
          key: "action_button",
          label: "Action"
        },
        {
          key: "groupcode",
          label: "Group Code",
          sortable: true
        },
        {
          key: "checklistdescription",
          label: "Description"
        },
        {
          key: "maintainedby",
          label: "Maintained By"
        }, 
        {
          key: "status",
          label: "Status"
        }
      ],
      items: [],
      warehouse: this.$store.getters.warehousecode
    };
  },
  methods: {
    onPrint: function(evt) {
      evt.preventDefault();
      // this.isHidden = true;
      var printButton = document.getElementById("printpagebutton");
      var printExport = document.getElementById("printexport");
      var breadView = document.getElementById("breadview");
      //Set the print button visibility to 'hidden'
      printButton.style.visibility = "hidden";
      printExport.style.visibility = "hidden";
      breadView.style.visibility = "hidden";
      //Print the page content
      window.print();
      printButton.style.visibility = "visible";
      printExport.style.visibility = "visible";
      breadView.style.visibility = "visible";
    },
    onexport: function() {
      JSONToCSVConvertor(this.items, "CheckList", true);
    },
    initTable() {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      let self = this;
      self.$store.commit("setLoading", true);
      let promise = api.instance.get(
        "itsek/get-checklist-list/?department=" +
          self.warehouse +
          "&param=&tk=" +
          self.perPage +
          "&pg=" +
          self.currentPage +
          "&groupId=" +
          self.$route.params.id
      );

      return promise
        .then(resp => {
          self.items = resp.data.checklist;
          self.totalItem = resp.data.totalItem;
          self.$store.commit("setLoading", false);
console.log('test', resp.data);
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          //   return items;
        })
        .catch(err => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          api.httpMsg(self, err.status, err.data);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },
    onPageSelect(page) {
      this.isBusy = true;
      let self = this;
      self.$store.commit("setLoading", true);
      let promise = api.instance.get(
        "itsek/get-checklist-list/?department=" +
          self.warehouse +
          "&param=&tk=" +
          self.perPage +
          "&pg=" +
          self.currentPage +
          "&groupId=" +
          self.$route.params.id
      );

      return promise
        .then(resp => {
          self.items = resp.data.checklist;
          self.totalItem = resp.data.totalItem;
          self.$store.commit("setLoading", false);

          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
        })
        .catch(err => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          api.httpMsg(self, err.status, err.data);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },
    onSelecteItemToDelete: function(param) {
      this.selectedItem = param;
      this.selectedItemLabel = this.selectedItem.checklistId;
      this.deleteModal = true;
    },
    onDeleteItem: function() {
      this.$store.commit("setLoading", true);
      api.instance
        .delete(
          "itsek/remove-checklist?checklistId=" + this.selectedItem.checklistId
        )
        .then(resp => {
          this.initTable();
          this.deleteModal = false;
          miniToastr.success(resp.data);
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          if (err.response.data === "") {
            api.httpMsg(this, err.status, err.data);
          } else {
            miniToastr.error(err.response.data);
          }
          this.$store.commit("setLoading", false);
        });
    },
    OnClinkNEwChecklist:function()
    {
      this.$router.push("/Maintenance/2017042410233814/new/check-setup/" + this.groupId);
    },
    OnClinkUpdateChecklist:function(val){
       this.$router.push("/Maintenance/2017042410233814/modify/check/" + val +"/" + this.$route.params.id);
    }
  },
  created: function() {
    this.initTable();
  }
  // computed() {
  //   sortOptions()
  //     .filter(f => f.sortable)
  //     .map(f => {
  //       return;
  //     });
  // }
};
</script>

